// Angular
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})

export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(): boolean {
        if (!this.isLogedIn())
            this.router.navigateByUrl('/login');

        return true;
    }

    isLogedIn() {
        const sessionstorage = sessionStorage.getItem('serviceAdmintoken');;
        return sessionstorage ? true : false;
    }   
}
